// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"alternative-id__visuallyhidden--qkjzx","focusable":"alternative-id__focusable--p8urO","section":"alternative-id__section--xjsAZ"};